<app-usr-new-followup>
  
</app-usr-new-followup>






<!-- <h4 class="title">Follow up Save</h4> -->
<!-- <mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">
  close</mat-icon>
<div class="row" style="margin-top: 5px;">
  <div class="col-md-9">
    <div class="card-box">
      <h4 class="title-f">Follow Up</h4>
      <div class="row" style="padding: 0px 0px 10px 10px; margin:10px;">
        <form [formGroup]="FollowUpForm">
          <div class="form-row">
            <div class="form-group col-md-3">
              <h5 class="form-lable">Action Date:</h5>
              <input type="date" pInputText placeholder=""  formControlName="action_date">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Action Start Time:</h5>
              <input type="time" placeholder="" formControlName="action_start_time">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Action Code:</h5>
              <input type="text" pInputText placeholder="" formControlName="action_code">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Contact Mode:</h5>
              <input type="text" pInputText placeholder="" formControlName="contact_mode">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Person Contacted:</h5>
              <input type="text" pInputText placeholder="" formControlName="person_contacted">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Place Contacted:</h5>
              <input type="text" pInputText placeholder="" formControlName="place_contacted">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Currency:</h5>
              <input type="text" pInputText placeholder="" formControlName="currency">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Action Amt.:</h5>
              <input type="text" pInputText placeholder="" formControlName="action_amount">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Action Amt. In Base Currency:</h5>
              <input type="text" pInputText placeholder="" formControlName="action_amount_base_currency">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Next Action Date:</h5>
              <input type="date" pInputText placeholder="" formControlName="next_action_date">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Next Action Time:</h5>
              <input type="time"  placeholder="" formControlName="next_action_time">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Reminder Mode:</h5>
              <input type="text" pInputText placeholder="" formControlName="remainder_mode">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Contacted By:</h5>
              <input type="text" pInputText placeholder="" formControlName="contacted_by">
            </div>
            <div class="form-group col-md-3">
              <h5 class="form-lable">Remarks</h5>
              <input type="text" pInputText placeholder="" formControlName="remarks">
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="col-md-3 mt-20">
              <button type="button" class="btn btn-primary" (click)="addFollowup()">Save</button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="card-box">
      <h4 class="title-f">Customer Memo Line</h4>
      <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-12">
          <textarea pInputTextarea (change)="getMemo($event)"></textarea>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="mt-20">
  <button type="button" (click)="table_s = !table_s" class="btn btn-primary">Settlement Recording</button>
  <a (click)="table_v = !table_v" class="link-a mt-20">View Follow Up History</a>

</div> -->

<!-- <ng-container  *ngIf="table_s == true">
  <div class="row">
    <div class="col-md-12">
      
      <div class="card-box">
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-3">
            <h5 class="form-lable">Loan No/Account No :</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Settlement:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Financier:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Customer Name:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">DPD>=:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Amount Overdue>=:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Product:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Queue:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">POS>=</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Unit Level:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>
          <div class="col-md-3">
            <h5 class="form-lable">Unid Code:</h5>
            <input type="text" pInputText placeholder="" value="">
          </div>

          <div class="col-md-3 mt-20">
            <button type="button" class="btn btn-primary">Search</button>
          </div>

        </div>

      </div>
    </div>
  </div>

  <ng-container> -->

    <!-- <h4 class="title">Collection Recording</h4> -->

    <!-- <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
        <ng-template pTemplate="header">
          <tr style="text-align: center;">
            <th>S.No</th>
            <th>Loan No./ Account No. </th>
            <th>Customer Name</th>
            <th>DPD>= </th>
            <th>Branch </th>
            <th>Product </th>
            <th>Queue </th>
            <th>Amount Outstanding</th>
            <th>Amount Overdue</th>
          </tr>
          <tr style="text-align: center;">
            <td>1</td>
            <td (click)="show()"><a class="link-a">01234567899</a></td>
            <td>Vignesh</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
            <td>NA</td>
          </tr>
        </ng-template>
       </p-table>  </div>
    </div> -->
    <!-- <br> -->
<!-- 
  </ng-container>
</ng-container> -->

<!-- <ng-container *ngIf="table_v == true"> -->
<!-- <ng-container>
  <h4 class="title">Follow up Trails</h4>
  <div class="doc-table">
    <div class="card-box"> <p-table [value]="followupList | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
      [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
      <ng-template pTemplate="header">
        <div style="overflow-x: scroll;">
          <table>
            <tr style="text-align: center;">
              <th>Loan Number *</th>
              <th>Product </th>
              <th>Bucket</th>
              <th>AGENT Name</th>
              <th>Action Date</th>
              <th>Action Time</th>
              <th>Contact Mode</th>
              <th>Place Contacted</th>
              <th>Person Contacted</th>
              <th>Action Code</th>
              <th>Action Amount</th>
              <th>Remarks</th>
              <th>Review Date</th>
              <th>Review Time</th>
              <th>Created by</th>
            </tr>
            <tr style="text-align: center;" *ngFor="let item of followupList">
              <td>#FIN001</td>
              <td>#FIN001</td>
              <td>#FIN001</td>
              <td>{{item.creator_name}}</td>
              <td>{{item.action_date | date}}</td>
              <td>{{item.action_start_time}}</td>
              <td>{{item.action_code}}</td>
              <td>{{item.contact_mode}}</td>
              <td>{{item.person_contacted}}</td>
              <td>{{item.place_contacted}}</td>
              <td>{{item.currency}}</td>
              <td>{{item.action_amount}}</td>
              <td>{{item.action_amount_base_currency}}</td>
              <td>{{item.next_action_date | date }}</td>
              <td>{{item.next_action_time}}</td>
              <td>{{item.remainder_mode}}</td>
              <td>{{item.contacted_by}}</td>
              <td>{{item.remarks}}</td>
              <td>{{item.cutsomer_memo_line}}</td>
            </tr>
          </table>
        </div>
      </ng-template>
     </p-table>  
    </div>
  </div>
  <br>

</ng-container> -->